import axios from 'axios'
import { REQUEST_BASE_URL } from './config'


// create an axios instance
const service = axios.create({
    baseURL: REQUEST_BASE_URL, // api 的 base_url
    timeout: 50000, // request timeout
})

var needLoadingRequestCount = 0
export function showFullScreenLoading() {
    needLoadingRequestCount++
}
export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
}

service.interceptors.request.use(
    function (config) {
        try {
            const jwt_token_str = window.localStorage.getItem('jwt_token')
            if (!config.headers) {
                config.headers = {}
            }
            if (jwt_token_str)
                config.headers.Authorization = 'Bearer ' + jwt_token_str
        } catch (e) {
            console.error('request intercepter request error: ', e)
        }
        showFullScreenLoading()
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (response) => {
        const { data } = response
        return data
    },
    (error) => {
        // 响应错误处理
        console.error('响应错误处理===: ', error)
        tryHideFullScreenLoading()
        return { success: false, error }
    }
)

export default service
